
<template>
  <!--新增卡卷-->
  <div class="advanced-form">
    <div class="card">
      <div class="card-head">
        <h3>下载模板，填写数据</h3>
      </div>
      <div class="card-body">
        <a-button @click="downTemplate" type="primary">下载模板</a-button>
      </div>
    </div>

    <div class="card">
      <div class="card-head">
        <h3>填写选项，选择要导入的数据后上传</h3>
      </div>
      <div class="card-body">
        <x-addEdit
          ref="addEdit"
          :itemLayout="{ labelCol: { span: 2 }, wrapperCol: { span: 9 }}"
          :formList="formList"
          :formKey="formKey"
          :addParam="addParam"
          :editParam="editParam"
          :detailParam="detailParam"
        >
        </x-addEdit>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addCoupon',
  data () {
    return {
      fileData: {},
      formList: [
        {
          label: '选择类型',
          inputType: 'select',
          options: [
            { label: '优惠券', value: '1' },
            { label: '卡密', value: '2' }
          ],
          handle: '',
          placeholder: '选择类型',
          props: ['type', {
            rules: [{required: true, message: '选择类型'}]
          }]
        },
        {
          label: '卡券名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入卡券名称',
          props: ['name', {
            rules: [
              {required: true, message: '请输入卡券名称'}
            ]
          }]
        },
        {
          label: '有效时间',
          inputType: 'rangeTimePick',
          options: [],
          handle: '',
          placeholder: ['有效时间', '有效时间'],
          props: ['expireTime', { // expireStartTime expireEndTime
            rules: [{required: true, message: '请选择有效时间'}]
          }]
        },
        {
          label: '选择文件',
          inputType: 'upload',
          options: [],
          handle: '',
          extra: '优惠券请上传单列的券码格式，卡密请上传双列的卡号+密码格式支持xlsx、xls格式',
          placeholder: '',
          fileList: [],
          beforeHandle: this.beforeHandle,
          uploadParam: {
            url: '',
            accept: this.$store.state.excelAccept
          },
          props: ['file', {
            rules: [{required: true, message: '请选择文件'}]
          }]
        }
      ],
      formKey: {
        type: undefined,
        name: undefined,
        expireTime: undefined,
        file: undefined
      },
      addParam: {
        url: '/pm/coupon',
        reqHandle: this.reqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  created () {
  },
  methods: {
    /** 下载模板 */
    downTemplate () {
      window.open(process.env.VUE_APP_BASE_API + '/pm/coupon/download');
    },
    /** 自定义房间数据 upload */
    beforeHandle (file, fileList) {
      this.fileData = file;
      const index = this.formList.findIndex(item => item.props && item.props[0] === 'file');
      this.formList[index].fileList = [{
        uid: file.uid,
        name: file.name,
        url: URL.createObjectURL(file)
      }];

      return false;
    },
    reqHandle (param) {
      param.expireStartTime = param.expireTime[0].format('YYYY-MM-DD HH:mm:ss');
      param.expireEndTime = param.expireTime[1].format('YYYY-MM-DD HH:mm:ss');
      delete param.expireTime;
      const formdata = new FormData();
      for (const item in param) {
        item !== 'file' && formdata.set(item, param[item]);
      }
      formdata.set('file', this.fileData);
      return formdata;
    },
    detailResHandle (res) {
      return res;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
